import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { Dropdown } from 'module/ui/components/atoms/dropdown/dropdown';
import { sortByText } from 'module/utils/sort-by-text';
import { Button } from '@rocketlane/ui';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { NoneField, NoneFieldKey } from './use-group-by-fields';

const ValueWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-01);
`;

interface Props {
  fields: FilterableField[];
  loading?: boolean;
  value?: string;
  onChange?: (value: string) => void;
}
export const PeopleListGroupBy: FC<Props> = ({
  fields,
  value,
  onChange,
  loading,
}) => {
  const menuItems = useMemo(() => {
    return fields
      .sort((a, b) => {
        if (a.fieldName === NoneFieldKey) {
          return -1;
        }
        if (b.fieldName === NoneFieldKey) {
          return 1;
        }

        return sortByText(a.fieldLabel, b.fieldLabel);
      })
      .map((field) => ({
        key: field.fieldName,
        label: field.fieldLabel,
      }));
  }, [fields]);
  const selectedField = useMemo(() => {
    return fields.find((field) => field.fieldName === value) ?? NoneField;
  }, [fields, value]);

  return (
    <Dropdown
      menu={{
        selectedKeys: [value ?? NoneFieldKey],
        items: menuItems,
        onClick: ({ key }) => onChange?.(key),
      }}
    >
      <Button variant="secondary" loading={loading}>
        <ValueWrapper>
          <FormattedMessage id="group_by" />:
          <strong>{selectedField?.fieldLabel}</strong>
        </ValueWrapper>
      </Button>
    </Dropdown>
  );
};
